import { Component, inject, OnInit, SecurityContext } from '@angular/core';
import { BuildingBlock, BuildingBlockControlBaseComponent } from '../building-block.types';
import { SafeResourceUrl } from '@angular/platform-browser';
import { GoogleTagManagerService } from '@cudirect/shared-ui-library';
import { AnalyticsMetadataService } from '@app/service/analytics-metadata.service';
import { WorkflowService } from '@workflow/service/workflow/workflow.service';

@BuildingBlock('payment-calc')
@Component({
  selector: 'cu-payment-calc',
  templateUrl: './payment-calculator.component.html'
})
export class PaymentCalculatorComponent extends BuildingBlockControlBaseComponent implements OnInit {
  public calcType = '';
  public isOpen = false;
  public iframeSrc: SafeResourceUrl;
  private readonly gtm = inject(GoogleTagManagerService);
  private readonly analyticsMetadataService = inject(AnalyticsMetadataService);

  public ngOnInit(): void {
    const base = this.environmentService?.ecpWorkflowEnvironment?.paymentCalculatorURL;
    if (!this.isURLSafe(base)) {
      console.error('Invalid URL for Payment Calculator');
      return;
    }
    const unSafeURL = this.generateURL(base);
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(unSafeURL);
  }

  private isURLSafe(url: string): boolean {
    return url?.endsWith('.calcxml.com');
  }

  private generateURL(base: string): string {
    if (!base) return;
    const payload = this.field?.config?.payload || {};
    let additionalParams = '';
    for (const key in payload) {
      if (payload.hasOwnProperty(key) && key !== 'type' && key !== 'skn' && key !== 'r') {
        additionalParams = additionalParams + `&${key}=${payload[key]}`;
      }
    }
    const skn = payload?.skn ? payload?.skn : 967;
    const type = payload?.type ? payload?.type : 'aut03';
    const r = payload?.r ? payload?.r : '1';
    return this.sanitizer.sanitize(SecurityContext.URL, `${base}/calculators/${type}?skn=${skn}&r=${r}${additionalParams}`);
  }

  public openSlideInPanel() {
    this.isOpen = true;
    const data = this.analyticsMetadataService.getMetadata(this.workflowService.currentPage);
    // Since the page name will be the same as another event, manually changing it to payment calculator.
    this.gtm.publishEvent('arcdx.loans.payment-calculator', data[1]);
  }

  adjustIframeHeight(event) {
    // Temp code to set iframe height dynamically
    event.target.style.height = event.target.ownerDocument.body.scrollHeight + 'px';
  }
}
